import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { outlinedStar, filledStar } from './paths';

const Svg = styled.svg<Pick<StarProps, 's'>>(({ s }) => ({
  width: '1rem',
  height: 'auto',
  fill: (s && s.color) || '#000',
  verticalAlign: 'initial',
  ...s,
}));

export interface StarProps {
  full?: boolean;
  half?: boolean;
  s?: CSSProperties;
}

function Star({ full, half, s }: StarProps): JSX.Element {
  return (
    <Svg s={s} viewBox="0 0 32 32">
      {full && <path d={filledStar} />}
      {half && (
        <>
          <defs>
            <clipPath id="half-clip">
              <rect x="0" y="0" width="16" height="32" />
            </clipPath>
          </defs>
          <path d={filledStar} clipPath="url(#half-clip)" />
          <path d={outlinedStar} />
        </>
      )}
      {!full && !half && <path d={outlinedStar} />}
    </Svg>
  );
}

export default Star;
